import * as tslib_1 from "tslib";
import { AbstractSearchCriteria } from '../../criteria/abstract-search-criteria';
var AllocationFeatureSearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(AllocationFeatureSearchCriteria, _super);
    function AllocationFeatureSearchCriteria() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AllocationFeatureSearchCriteria;
}(AbstractSearchCriteria));
export { AllocationFeatureSearchCriteria };
